import { Checkbox } from 'antd';
import { CustomDatePicker, CustomInput } from 'components/custom';
import CustomDropdown from 'components/dropdown/custom_select';
import dayjs from 'dayjs';
import { FormikProps } from 'formik';
import { modules, platformAccess, user_profile } from 'utils';
import { validateSpace } from 'utils/common_function';
import {
  lengthRegex,
  lowercaseRegex,
  numberRegex,
  uppercaseRegex,
} from 'utils/regex/regexPassword';

type AdminInfoProps = {
  user?: any;
  onUpdateData?: (data: object) => void;
  formik?: FormikProps<any>;
};

const AdminInfo = ({ user, formik }: AdminInfoProps) => {
  const password = formik.values.password || '';

  const hasLength = lengthRegex.test(password);
  const hasLowercase = lowercaseRegex.test(password);
  const hasUppercase = uppercaseRegex.test(password);
  const hasNumber = numberRegex.test(password);

  return (
    <div>
      <h1
        style={{
          fontWeight: 500,
          fontSize: '20px',
          marginTop: 10,
          color: '#000000',
        }}
      >
        Platform Access
      </h1>
      <div style={{ display: 'flex', gap: 32, marginTop: 32 }}>
        <div style={{ width: '50%' }}>
          <CustomDropdown
            disabled
            defaultKey={formik?.values?.role}
            width="100%"
            height={50}
            fontSize={12}
            showIconWhenDisabled
            defaultBorder="6px"
            title="User Profile"
            options={user_profile}
            // onSelect={(data) => {
            //   if (formik?.values?.role !== data)
            //     formik?.setFieldValue('role', data);
            // }}
          />
        </div>
        <div style={{ width: '50%' }} className="show_item_date">
          <CustomDatePicker
            disabled={user?.role === 'admin'}
            value={
              formik?.values?.expired_date
                ? dayjs(formik?.values?.expired_date)
                : undefined
            }
            title="End of access"
            height={50}
            fontSize={12}
            borderRadius={6}
            onChange={(e) => {
              formik.setFieldValue('expired_date', e?.format('YYYY-MM-DD'));
            }}
          />
        </div>
      </div>
      <div style={{ marginTop: '40px', display: 'flex', gap: 80 }}>
        {platformAccess.map((item) => (
          <Checkbox
            key={item.value}
            name={item.value}
            checked={formik.values[item.value]}
            defaultChecked={formik.values[item.value]}
            onChange={formik.handleChange}
          >
            {item.label}
          </Checkbox>
        ))}
      </div>
      <h1
        style={{
          marginTop: '32px',
          fontWeight: 500,
          fontSize: '16px',
          color: '#000000',
        }}
      >
        Modules
      </h1>
      <div style={{ marginTop: '32px' }}>
        <Checkbox.Group
          style={{ gap: 50 }}
          defaultValue={formik.values?.active_modules}
          value={formik.values?.active_modules}
          onChange={(value) => {
            formik.setFieldValue('active_modules', value);
          }}
          options={modules}
        />
      </div>
      <h1
        style={{
          margin: '32px 0',
          fontWeight: 500,
          fontSize: '20px',
          color: '#000000',
        }}
      >
        Password
      </h1>
      <div
        style={{
          flexDirection: 'column',
          display: 'flex',
          width: '50%',
          color: '#E02C2C',
          fontSize: '12px',
          gap: 4,
        }}
      >
        <span
          style={{
            color: hasLength ? '#52C41A' : '#E02C2C',
            transition: 'all ease-in-out',
            transitionDuration: '300ms',
          }}
        >
          Must be at least 8 characters in length{' '}
        </span>
        <span
          style={{
            color: hasLowercase ? '#52C41A' : '#E02C2C',
            transition: 'all ease-in-out',
            transitionDuration: '300ms',
          }}
        >
          Must contains at least one lower-case letter{' '}
        </span>
        <span
          style={{
            color: hasUppercase ? '#52C41A' : '#E02C2C',
            transition: 'all ease-in-out',
            transitionDuration: '300ms',
          }}
        >
          Must contains at least upper-case letter{' '}
        </span>
        <span
          style={{
            color: hasNumber ? '#52C41A' : '#E02C2C',
            transition: 'all ease-in-out',
            transitionDuration: '300ms',
          }}
        >
          Must contain at least one number{' '}
        </span>
      </div>
      <div style={{ display: 'flex', gap: 32, marginTop: 24 }}>
        <div style={{ width: '50%' }}>
          <CustomInput
            onChange={formik?.handleChange}
            value={formik?.values?.password}
            name="password"
            height="50px"
            fontSize={12}
            error={
              !(hasLength && hasLowercase && hasUppercase && hasNumber) &&
              formik?.values?.password
            }
            onKeyDown={validateSpace}
            width="100%"
            title="New password"
            maxLength={20}
          />
        </div>
        <div style={{ width: '50%' }}>
          <CustomInput
            width="100%"
            height="50px"
            error={
              formik?.values?.confirm_password &&
              formik?.values?.confirm_password !== formik?.values?.password
            }
            onChange={formik?.handleChange}
            onKeyDown={validateSpace}
            name="confirm_password"
            value={formik.values?.confirm_password}
            fontSize={12}
            title="Confirm new password"
            maxLength={20}
          />
        </div>
      </div>
      {/* <h1 style={{ marginTop: 32 }}>Rights</h1>
      <div style={{ marginTop: '32px' }}>
        <Checkbox.Group style={{ gap: 50 }} options={adminRights} />
      </div> */}
    </div>
  );
};

export default AdminInfo;
